import { render, staticRenderFns } from "./OnboardingV2.vue?vue&type=template&id=7590b68a&scoped=true&"
import script from "./OnboardingV2.vue?vue&type=script&lang=js&"
export * from "./OnboardingV2.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingV2.vue?vue&type=style&index=0&id=7590b68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590b68a",
  null
  
)

export default component.exports